"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgCards = function (_a) {
    var primaryColor = _a.primaryColor, secondaryColor = _a.secondaryColor, tertiaryColor = _a.tertiaryColor, props = __rest(_a, ["primaryColor", "secondaryColor", "tertiaryColor"]);
    return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 12 12" }, props),
        react_1.default.createElement("path", { stroke: primaryColor, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: 0.95, strokeWidth: 0.75, d: "M4.906 2.617c-1.25.322-2.216.702-3.465 1.366a.834.834 0 0 0-.42.922c.49 2.161.996 3.546 2.024 5.51a.835.835 0 0 0 .912.43c1.813-.386 2.941-.826 4.668-1.795a.165.165 0 0 0 .08-.18" }),
        react_1.default.createElement("path", { stroke: primaryColor, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: 0.95, strokeWidth: 0.75, d: "M5.103 1.817a.835.835 0 0 1 .773-.656c1.677-.08 2.823.03 4.458.396a.839.839 0 0 1 .653.797c.058 2.216-.071 3.672-.515 5.818a.836.836 0 0 1-.771.667c-1.683.092-2.83-.011-4.473-.397a.835.835 0 0 1-.642-.779c-.094-2.214.039-3.682.517-5.846Z" })));
};
exports.default = SvgCards;
